import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Gender, Salutation } from "../../components/JobInputData";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { applicantPost, reset } from "../../features/Applicant/applicantSlice";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import Copyright from "../../components/ModalComponents/Copyright";
import { Spinners } from "../../components/TableOptions";
import moment from "moment";
import { AiFillMinusCircle } from "react-icons/ai";
import DragDropFile from "../Hire/DragDropFile";
import { MdOutlineClose } from "react-icons/md";
import { IoMdAddCircle, IoMdCreate } from "react-icons/io";
import { getalljobs } from "../../features/Job/jobSlice";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Typography from "@material-ui/core/Typography";
import UploadID from "../Hire/UploadID";

function getSteps() {
  return [<b>Upload Your CV</b>, <b>Upload Identification With Date of Birth</b>];
}

function getStepContent(
  step: number,
  setInputs: any,
  setActiveStep: any
) {


  switch (step) {
    case 0:
      return (
        <DragDropFile setInputs={setInputs} setActiveStep={setActiveStep} />
      )
    case 1:
      return (
        <UploadID setInputs={setInputs} />
      )
    default:
      return "Unknown step";
  }
}


const NewApplicant = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const { isErrorapp, isLoadingapp, messageapp, isSuccessapp } = useAppSelector(
    (state: any) => state.applicant
  );

  const { data: datas } = useAppSelector((state: any) => state.job);
  const date = moment().startOf('day');
  const result = datas?.data?.reduce((acc: { active: any[]; dropout: any[]; }, obj: { expiryDate: moment.MomentInput; }) => {
    const expiryDate = moment(obj?.expiryDate).startOf('day');
    if (expiryDate.isSameOrAfter(date)) {
      acc?.active?.push(obj);
    } else {
      acc?.dropout?.push(obj);
    }
    return acc;
  }, { active: [], dropout: [] });

  const actives = result?.active;



  useEffect(() => {
    dispatch(getalljobs());
  }, [dispatch]);


  const [date1, setDate1] = useState([
    {
      id: 1,
      school: "",
      course: "",
      startDate: "",
      endDate: "",
    },
  ]);
  const [date2, setDate2] = useState([
    {
      id: 1,
      company: "",
      role: "",
      startDate: "",
      endDate: "",
    },
  ]);

  // --- Adds New Field --- //
  const handleAddField1 = () => {
    setDate1([
      ...date1,
      {
        id: date1.length + 1,
        school: "",
        course: "",
        startDate: "",
        endDate: "",
      },
    ]);
  };

  // --- Adds New Field --- //
  const handleAddField2 = () => {
    setDate2([
      ...date2,
      {
        id: date2.length + 1,
        company: "",
        role: "",
        startDate: "",
        endDate: "",
      },
    ]);
  };

  const [inputs, setInputs] = useState({
		title: "",
		firstName: "",
		middleName: "",
		LastName: "",
		// @ts-ignore
		email: "",
		linkedInUrl: "",
		phoneNumber: "",
		location: "",
		currency: "NGN",
		currentSalary: "₦",
		expectedSalary: "₦",
		relevantWorkExperience: "",
		noticePeriod: "",
		reasonForChange: "",
		additionalDetails: "",
		totalWorkExperience: "",
		resume: "",
		verificationID: "",
		// @ts-ignore
		jobId: "",
		Education: [],
		WorkExperience: [],
		gender: "",
		dateOfBirth: "",
	});


  const date1a: any = date1?.map((item: any) => ({
    school: item.school,
    course: item.course,
    startDate: item.startDate,
    endDate: item.endDate,
  }));
  const date2a: any = date2?.map((item: any) => ({
    company: item.company,
    role: item.role,
    startDate: item.startDate,
    endDate: item.endDate,
  }));

  useEffect(() => {
    inputs.Education = date1a;
    inputs.WorkExperience = date2a;
  }, [date1a, date2a, inputs]);

  const handleData1 = (input: any, value: any, index: any) => {
    let items = [...date1];
    let oldItem = items.findIndex((x) => x.id === index);
    let newItem = {
      ...items[oldItem],
      [input]:
        input === "startDate" || input === "endDate"
          ? moment(new Date(value)).format()
          : value,
    };
    items[oldItem] = newItem;
    setDate1(items);
  };

  const handleData2 = (input: any, value: any, index: any) => {
    let items = [...date2];
    let oldItem = items.findIndex((x) => x.id === index);
    let newItem = {
      ...items[oldItem],
      [input]:
        input === "startDate" || input === "endDate"
          ? moment(new Date(value)).format()
          : value,
    };
    items[oldItem] = newItem;
    setDate2(items);
  };

  // --- Remove New Field   --- //
  const handleRemoveField1 = (index: any) => {
    const field = [...date1];
    field.splice(index, 1);
    setDate1(field);
  };
  // --- Remove New Field   --- //
  const handleRemoveField2 = (index: any) => {
    const field = [...date2];
    field.splice(index, 1);
    setDate2(field);
  };

  useEffect(() => {
    if (isErrorapp) {
      swal({
        title: "error",
        text: messageapp,
        icon: "error",
      });
    } else if (isSuccessapp) {
      swal({
        title: "success",
        text: "Your Application Is Sucessful!",
        icon: "success",
      }).then((okay) => {
        if (okay) {
          navigate(-1);
        }
      });
    }
    dispatch(reset());
  }, [dispatch, isErrorapp, isSuccessapp, messageapp, navigate]);

  const handleOnChange = (input: any, value: any) => {
    setInputs((prevState: any) => ({
      ...prevState,
      [input]: value,
    }));
  };

  const handlePost = async (e: any) => {
    e.preventDefault();
    // @ts-ignore
    dispatch(applicantPost(inputs));
  };

  const handelmodalclose = () => {
    navigate("/applicants");
  };


  return (
    <div id='header' className='HireForm-container'>
      <header className='ChatProgressView-header'>
        <div className='Update-titile-icon'>
          <IoMdCreate color='#005b90' />
          <div className='in-progresss' style={{ color: "005b90" }}>
            Create New Applicant
          </div>
        </div>

        <div
          className='ChatProgressView-close'
          onClick={handelmodalclose}
          style={{ backgroundColor: "#005b90" }}
        >
          <MdOutlineClose
            size={25}
            style={{ color: "white" }}
            className='ChatProgressView-close-icon'
          />
        </div>
      </header>
      <main>
        <div className="addsteppercontainer_sup mb-4">
          <div className="addsteppercontainer">
            <Stepper activeStep={activeStep} orientation='vertical'>
              {steps.map((label, index) => (
                <Step key={index}>
                  <StepLabel>{label}</StepLabel>
                  <StepContent>
                    <Typography>
                      {getStepContent(
                        index,
                        setInputs,
                        setActiveStep
                      )}
                    </Typography>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </div>
        </div>
        <form onSubmit={handlePost}>
          <div>
            <div className='Hire-first-second-main-container Hire-main-apply'>
              <div id='Profile__Information'>
                <div className='applicant__Title'>
                  <h5>Select the Job you want to apply for</h5>
                </div>
                <div
                  className='New__applicant__row'
                  style={{ width: "100%" }}
                >
                  <p>Select Job</p>
                  <select
                    className='round'
                    value={inputs.jobId}
                    onChange={(e) =>
                      handleOnChange("jobId", e.target.value)
                    }
                  >
                    <option>Salutation</option>
                    {actives?.map((item: any, i: any) => (
                      <option key={i} value={item?.id}>
                        {item?.jobFunction}
                      </option>
                    ))}
                  </select>
                </div>
                <div className='applicant__Title'>
                  <p>Profile Information</p>
                </div>
                <div className='Information__basic'>
                  <div className='Basic__Info'>
                    <div
                      className='New__applicant__row'
                      style={{ width: "15%" }}
                    >
                      <p>Title</p>
                      <select
                        className='round'
                        value={inputs.title}
                        onChange={(e) =>
                          handleOnChange("title", e.target.value)
                        }
                      >
                        <option>Salutation</option>
                        {Salutation.map((item: any, i: any) => (
                          <option key={i} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className='New__applicant__row'>
                      <p>First Name </p>
                      <input
                        type='text'
                        className='AddJobinput'
                        style={{ marginBottom: "15px" }}
                        value={inputs.firstName}
                        onChange={(e) =>
                          handleOnChange("firstName", e.target.value)
                        }
                        placeholder='First Name'
                      />
                    </div>

                    <div className='New__applicant__row'>
                      <p>Middle Name </p>
                      <input
                        type='text'
                        className='AddJobinput'
                        style={{ marginBottom: "15px" }}
                        value={inputs.middleName}
                        onChange={(e) =>
                          handleOnChange("middleName", e.target.value)
                        }
                        placeholder='Middle Name'
                      />
                    </div>

                    <div className='New__applicant__row'>
                      <p>Last Name </p>
                      <input
                        type='text'
                        className='AddJobinput'
                        style={{ marginBottom: "15px" }}
                        value={inputs.LastName}
                        onChange={(e) =>
                          handleOnChange("LastName", e.target.value)
                        }
                        placeholder='Last Name'
                      />
                    </div>
                  </div>
                  <div className="Basic__Info">
  <div className="New_applicant_row">
    <p>Gender</p>
    <select 
      className="round" 
      value={inputs?.gender} 
      onChange={(e) => handleOnChange("gender", e.target.value)} 
      required
    >
      <option value="">Select Gender</option>
      {Gender?.map((item: any, i: number) => (
        <option key={i} value={item}>
          {item}
        </option>
      ))}
    </select>
  </div>
</div>
                  <div className='email__row'>
                    <p>Email </p>
                    <input
                      type='text'
                      className='AddJobinput'
                      style={{ marginBottom: "15px" }}
                      value={inputs.email}
                      onChange={(e) => handleOnChange("email", e.target.value)}
                      placeholder='Email'
                    />
                  </div>
                  <div className='linkedin__row'>
                    <p>LinkedIn Url </p>

                    <input
                      type='text'
                      className='AddJobinput'
                      style={{ marginBottom: "15px" }}
                      value={inputs.linkedInUrl}
                      onChange={(e) =>
                        handleOnChange("linkedInUrl", e.target.value)
                      }
                      placeholder='LinkedIn Url'
                    />
                  </div>
                  <div id='Salary__Info'>
                    <div
                      className='New__applicant__row'
                      style={{ width: "95%" }}
                    >
                      <p>Phone </p>
                      <input
                        type='text'
                        className='AddJobinput'
                        style={{ marginBottom: "15px" }}
                        value={inputs.phoneNumber}
                        onChange={(e) =>
                          handleOnChange("phoneNumber", e.target.value)
                        }
                        placeholder='Phone Number'
                      />
                    </div>
                    <div className='New__applicant__row'>
                      <p>Location </p>

                      <input
                        type='text'
                        className='AddJobinput'
                        style={{ marginBottom: "15px" }}
                        value={inputs.location}
                        onChange={(e) =>
                          handleOnChange("location", e.target.value)
                        }
                        placeholder='Location'
                      />
                    </div>

                    <div
                      className='New__applicant__row'
                      style={{ width: "95%" }}
                    >
                      <p>Currency </p>
                      <input
                        type='text'
                        className='AddJobinput'
                        style={{ marginBottom: "15px" }}
                        disabled={true}
                        value={inputs.currency}
                        onChange={(e) =>
                          handleOnChange("currency", e.target.value)
                        }
                        placeholder='Currency'
                      />
                    </div>

                    <div className='New__applicant__row'>
                      <p>Current Salary </p>
                      <input
                        type='text'
                        className='AddJobinput'
                        style={{ marginBottom: "15px" }}
                        value={inputs.currentSalary}
                        onChange={(e) =>
                          handleOnChange("currentSalary", e.target.value)
                        }
                        placeholder='Currency'
                      />
                    </div>
                    <div
                      className='New__applicant__row'
                      style={{ width: "95%" }}
                    >
                      <p>Expected Salary </p>

                      <input
                        type='number'
                        className='AddJobinput'
                        style={{ marginBottom: "15px" }}
                        value={inputs.expectedSalary}
                        onChange={(e) =>
                          handleOnChange("expectedSalary", e.target.value)
                        }
                        placeholder='Expected Salary'
                      />
                    </div>
                  </div>
                  <div className='notice__period'>
                    <p>Notice Period (In Days) </p>
                    <input
                      type='text'
                      className='AddJobinput'
                      style={{ marginBottom: "15px" }}
                      value={inputs.noticePeriod}
                      onChange={(e) =>
                        handleOnChange("noticePeriod", e.target.value)
                      }
                      placeholder='Notice Period'
                    />
                  </div>
                  <div className='change__reason'>
                    <p>Reason for Job Change </p>
                    <input
                      type='text'
                      className='AddJobinput'
                      style={{ marginBottom: "15px" }}
                      value={inputs.reasonForChange}
                      onChange={(e) =>
                        handleOnChange("reasonForChange", e.target.value)
                      }
                      placeholder='Reason for Job Change'
                    />
                  </div>
                  <div className='additional__information'>
                    <p>Additional Details </p>
                    <input
                      type='text'
                      className='AddJobinput'
                      style={{ marginBottom: "15px" }}
                      value={inputs.additionalDetails}
                      onChange={(e) =>
                        handleOnChange("additionalDetails", e.target.value)
                      }
                      placeholder='Additional Details'
                    />
                  </div>
                  <div className='additional__information'>
                    <p>Total Work Experience </p>
                    <input
                      type='number'
                      className='AddJobinput'
                      style={{ marginBottom: "15px" }}
                      value={inputs.totalWorkExperience}
                      onChange={(e) =>
                        handleOnChange("totalWorkExperience", e.target.value)
                      }
                      placeholder='Total Work Experience'
                    />
                  </div>

                  <div className='additional__information'>
                    <p>Relevant Work Experience </p>
                    <input
                      type='number'
                      className='AddJobinput'
                      style={{ marginBottom: "15px" }}
                      value={inputs.relevantWorkExperience}
                      onChange={(e) =>
                        handleOnChange("relevantWorkExperience", e.target.value)
                      }
                      placeholder='Relevant Work Experience'
                      required
                    />
                  </div>

                  <div className='additional__information'>
                    <p>Resume </p>
                    <input
                      type='text'
                      className='AddJobinput'
                      style={{ marginBottom: "15px" }}
                      value={inputs.resume}
                      onChange={(e) => handleOnChange("resume", e.target.value)}
                      placeholder='Resume'
                      required
                      disabled
                    />
                  </div>

                  <div className='additional__information'>
                    <p>Verification Indentificaton</p>
                    <input
                      type='text'
                      className='AddJobinput'
                      style={{ marginBottom: "15px" }}
                      value={inputs.verificationID}
                      onChange={(e) => handleOnChange("verificationID", e.target.value)}
                      placeholder='Verification Indentificaton with date of birth'
                      required
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              className='Hire-first-second-main-container Hire-main-apply'

            >
              <div id='Total__Experience'>
                {date1?.map((item: any, index: any) => (
                  <div className='Information__basic' key={index}>
                    <div className='Recruiting__infoBox'>
                      <div className='Recruiting-tab-add'>
                        <p>Education</p>
                        <div>
                          {index === 0 ? (
                            <Button onClick={handleAddField1}>
                              <IoMdAddCircle
                                size={25}
                                className='Recruiting-tab-add-btn'
                              />
                            </Button>
                          ) : (
                            <Button onClick={handleRemoveField1}>
                              <AiFillMinusCircle
                                size={25}
                                className='Recruiting-tab-add-btn1'
                              />
                            </Button>
                          )}
                        </div>
                      </div>
                      <hr />
                      <div className='Recruiting__info'>
                        <div
                          className='New__applicant__column'
                          style={{ width: "95%" }}
                        >
                          <p> School </p>
                          <input
                            type='text'
                            className='AddJobinput'
                            style={{ marginBottom: "15px" }}
                            value={item.school}
                            onChange={(e) =>
                              handleData1("school", e.target.value, item.id)
                            }
                            placeholder='School'
                            required
                          />
                        </div>

                        <div className='New__applicant__column'>
                          <p>Course </p>
                          <input
                            type='text'
                            className='AddJobinput'
                            style={{ marginBottom: "15px" }}
                            value={item.course}
                            onChange={(e) =>
                              handleData1("course", e.target.value, item.id)
                            }
                            placeholder='course'
                            required
                          />
                        </div>

                        <div
                          className='New__applicant__column'
                          style={{ width: "95%" }}
                        >
                          <p> Start Date </p>
                          <input
                            type='date'
                            className='AddJobinput'
                            style={{ marginBottom: "15px" }}
                            value={moment(new Date(item.startDate)).format(
                              "YYYY-MM-DD"
                            )}
                            onChange={(e) =>
                              handleData1("startDate", e.target.value, item.id)
                            }
                            placeholder='Start Date1'
                            required
                          />
                        </div>

                        <div className='New__applicant__column'>
                          <p>End Date </p>
                          <input
                            type='date'
                            className='AddJobinput'
                            style={{ marginBottom: "15px" }}
                            value={moment(new Date(item.endDate)).format(
                              "YYYY-MM-DD"
                            )}
                            onChange={(e) =>
                              handleData1("endDate", e.target.value, item.id)
                            }
                            placeholder='End Date'
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              className='Hire-first-second-main-container Hire-main-apply' >
              <div id='Total__Experience'>
                {date2?.map((item: any, index: any) => (
                  <div className='Information__basic' key={index}>
                    <div className='Recruiting__infoBox'>
                      <div className='Recruiting-tab-add'>
                        <p>Work Experience</p>
                        <div>
                          {index === 0 ? (
                            <Button onClick={handleAddField2}>
                              <IoMdAddCircle
                                size={25}
                                className='Recruiting-tab-add-btn'
                              />
                            </Button>
                          ) : (
                            <Button onClick={handleRemoveField2}>
                              <AiFillMinusCircle
                                size={25}
                                className='Recruiting-tab-add-btn1'
                              />
                            </Button>
                          )}
                        </div>
                      </div>
                      <hr />
                      <div className='Recruiting__info'>
                        <div
                          className='New__applicant__column'
                          style={{ width: "95%" }}
                        >
                          <p>Company </p>
                          <input
                            type='text'
                            className='AddJobinput'
                            style={{ marginBottom: "15px" }}
                            // @ts-ignore
                            value={item.company}
                            // @ts-ignore
                            onChange={(e) =>
                              handleData2("company", e.target.value, item.id)
                            }
                            placeholder='Company'
                            required
                          />
                        </div>

                        <div className='New__applicant__column'>
                          <p>Role </p>
                          <input
                            type='text'
                            className='AddJobinput'
                            style={{ marginBottom: "15px" }}
                            value={item.role}
                            onChange={(e) =>
                              handleData2("role", e.target.value, item.id)
                            }
                            placeholder='role'
                            required
                          />
                        </div>

                        <div
                          className='New__applicant__column'
                          style={{ width: "95%" }}
                        >
                          <p>Start Date </p>
                          <input
                            type='date'
                            className='AddJobinput'
                            style={{ marginBottom: "15px" }}
                            value={moment(new Date(item.startDate)).format(
                              "YYYY-MM-DD"
                            )}
                            onChange={(e) =>
                              handleData2("startDate", e.target.value, item.id)
                            }
                            placeholder='Start Date'
                            required
                          />
                        </div>
                        <div className='New__applicant__column'>
                          <p>End Date </p>

                          <input
                            type='date'
                            className='AddJobinput'
                            style={{ marginBottom: "15px" }}
                            // @ts-ignore
                            value={moment(new Date(item.endDate)).format(
                              "YYYY-MM-DD"
                            )}
                            // @ts-ignore
                            onChange={(e) =>
                              handleData2("endDate", e.target.value, item.id)
                            }
                            placeholder='End Date'
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className='Hire-first-second-main-container Hire-main-apply'>
              <div className='hire-apply-btn-container'>
                {isSuccessapp ? (
                  ""
                ) : (
                  <Button
                    type='submit'
                    variant='contained'
                    className='summary-bottom-btn'
                  >
                    {isLoadingapp ? <Spinners size={"md"} /> : "Apply"}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </form>
        <Copyright />
      </main>
    </div>
  );
};
export default NewApplicant;
